import React, { useMemo } from 'react'
import { Row } from 'react-bootstrap'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import { withJsonFormsControlProps } from '@jsonforms/react'

import { JsonForms } from '@jsonforms/react'

import { materialRenderers, materialCells } from '@jsonforms/material-renderers'

import DropModal from './modal/DropModal'
import CustomModalSystem from './modal/ModalSystem'
import CustomModalDisplay from './modal/ModalDisplay'

import { modalBody } from './modal/ModalBody'
import { modalFooter } from './modal/ModalFooter'

export const ModalDisplay = (props) => {
  return <CustomModalDisplay {...props} />
}

export const ModalSystem = (props) => {
  let { data, schema, uischema, path, handleChange } = props

  const renderers = useMemo(
    () => [...materialRenderers, modalBody, modalFooter],
    [JSON.stringify(uischema.elements)]
  )

  return (
    <Row className="w-100 mx-auto">
      <CustomModalSystem {...props} />
      <DropModal {...props}>
        <p
          className="position-absolute d-flex align-items-end m-0"
          style={{ top: '5px' }}
        >
          ออกแบบ Modal
          <span className="text-danger ml-1">*ส่วนนี้จะไม่แสดงบน display*</span>
        </p>
        <JsonForms
          schema={schema}
          uischema={uischema}
          data={data}
          renderers={renderers}
          cells={materialCells}
          onChange={({ data, errors }) => {
            handleChange(path, data)
          }}
        />
      </DropModal>
    </Row>
  )
}

export const modalTester = rankWith(3, scopeEndsWith('modal'))

export const modalDisplay = {
  tester: modalTester,
  renderer: withJsonFormsControlProps(ModalDisplay),
}

export const modalSystem = {
  tester: modalTester,
  renderer: withJsonFormsControlProps(ModalSystem),
}
